import 'jquery';

/**
 * toggles disabled state on submit buttons
 * adds class filled to each filled input
 *
 */
(function ($) {

  let toggle = $('[data-collapse-source]');

  if (!toggle.length) {
    return;
  }

  let targetSelector = toggle.data('collapse-source');
  let target = $( '[data-collapse-target="' + targetSelector + '"]' );

  if (!target.length) {
    return;
  }

  target.hide();

  // button texts
  let open = toggle.data('collapse-open') || toggle.text(),
    close = toggle.data('collapse-close') || toggle.text();

  toggle.on('click', function () {
    target.toggle('fast', function () {
      if (target.is(':visible')) {
        toggle.text(close);
      } else {
        toggle.text(open);
      }
      $('body').trigger('plenigo.resize');
    });
  });

}(jQuery));
